import styled from 'styled-components';

import { MinBreakpointV2 } from '@xemplo/style-constants';

export {
  CardContainer,
  Header,
  IconWrapper,
  Title,
  Field,
  Label,
  Value,
} from '../shared/card-styles';

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  /* Small screen order: Company details first, then due dates */
  [data-field-id='company'] {
    order: 1;
  }
  [data-field-id='business-unit'] {
    order: 2;
  }
  [data-field-id='business-model'] {
    order: 3;
  }
  [data-field-id='amendments-due'] {
    order: 4;
  }
  [data-field-id='pay-run-preparation-due'] {
    order: 5;
  }
  [data-field-id='approval-due'] {
    order: 6;
  }
  [data-field-id='finalise-due'] {
    order: 7;
  }
  [data-field-id='payment-due'] {
    order: 8;
  }

  /* Large screen order */
  @media ${MinBreakpointV2.medium} {
    grid-template-columns: 1fr 1fr;

    [data-field-id='amendments-due'] {
      order: 1;
    }
    [data-field-id='company'] {
      order: 2;
    }
    [data-field-id='pay-run-preparation-due'] {
      order: 3;
    }
    [data-field-id='business-unit'] {
      order: 4;
    }
    [data-field-id='approval-due'] {
      order: 5;
    }
    [data-field-id='business-model'] {
      order: 6;
    }
    [data-field-id='finalise-due'] {
      order: 7;
    }
    [data-field-id='payment-due'] {
      order: 8;
    }
  }
`;
